(() => {
  // すべての名前空間を aw-page-guide に完全に統一しました
  const selectors = {
    root: "[data-aw-page-guide]",
    triggerFlower: "[data-aw-page-guide-flower]",
    triggerMail: "[data-aw-page-guide-mail]",
    modal: "[data-aw-page-guide-modal]",
    close: "[data-aw-page-guide-modal-close]"
  };

  const instances = new Map();

  class AWPageGuideModal {
    constructor(root) {
      this.root = root;
      
      // トリガー要素の取得
      this.triggerFlower = root.querySelector(selectors.triggerFlower);
      this.triggerMail = root.querySelector(selectors.triggerMail);
      
      // モーダルが外側にあるため、document から全体を探します
      this.modals = Array.from(document.querySelectorAll(selectors.modal));
      
      this.onKeydown = this.handleKeydown.bind(this);
      
      this.bind();
    }

    bind() {
      // フラワーホールのボタン -> 1番目のモーダル
      if (this.triggerFlower) {
        this.triggerFlower.addEventListener("click", () => this.open(0, this.triggerFlower));
      }

      // メール注意事項のボタン -> 2番目のモーダル
      if (this.triggerMail) {
        this.triggerMail.addEventListener("click", () => this.open(1, this.triggerMail));
      }

      // 閉じるボタン・背景クリックのイベント設定
      this.modals.forEach((modal) => {
        const closes = modal.querySelectorAll(selectors.close);
        closes.forEach((button) => {
          button.addEventListener("click", () => this.close(modal));
        });
      });
    }

    open(index, trigger) {
      const modal = this.modals[index];
      if (!modal) return;

      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      modal.openerTrigger = trigger;

      document.body.classList.add("is-aw-page-guide-modal-open");
      document.addEventListener("keydown", this.onKeydown);
    }

    close(modal) {
      if (!modal) return;

      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");

      const hasOpenModal = this.modals.some(m => m.hidden === false);
      if (!hasOpenModal) {
        document.body.classList.remove("is-aw-page-guide-modal-open");
        document.removeEventListener("keydown", this.onKeydown);
      }

      if (modal.openerTrigger) {
        modal.openerTrigger.focus();
        modal.openerTrigger = null;
      }
    }

    handleKeydown(event) {
      if (event.key === "Escape") {
        this.modals.forEach((modal) => {
          if (!modal.hidden) this.close(modal);
        });
      }
    }

    destroy() {
      this.modals.forEach((modal) => {
        if (!modal.hidden) this.close(modal);
      });
    }
  }

  function init(root) {
    const sectionId = root.closest("[id]")?.id || root.dataset.sectionId || `aw-page-guide-${instances.size}`;

    if (instances.has(sectionId)) {
      instances.get(sectionId).destroy();
    }

    instances.set(sectionId, new AWPageGuideModal(root));
  }

  function initAll(container = document) {
    container.querySelectorAll(selectors.root).forEach(init);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector(selectors.root);
    if (!root) return;

    const sectionId = root.closest("[id]")?.id || root.dataset.sectionId;
    const instance = sectionId ? instances.get(sectionId) : null;

    if (instance) {
      instance.destroy();
      instances.delete(sectionId);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }
})();